module.exports = __webpack_public_path__ + "img/coupon-nodata.0347f82b.png";